import { HistoryEntity } from 'commons/types/DTO/bank/historyAudit'

export class ConnectionsDetailsFormPayload {
  licenseId = 0
  bioTrackHistoryPages: { [key: string]: number }
  bioTrackHistorySizes: { [key: string]: number }
  dutchieHistoryPages: { [key: string]: number }
  dutchieHistorySizes: { [key: string]: number }
  metrcHistoryPages: { [key: string]: number }
  metrcHistorySizes: { [key: string]: number }

  constructor(licenseId: number, form?: ConnectionsDetailsFormPayload) {
    this.licenseId = licenseId

    if (form) {
      this.bioTrackHistoryPages = form.bioTrackHistoryPages
      this.bioTrackHistorySizes = form.bioTrackHistorySizes
      this.dutchieHistoryPages = form.dutchieHistoryPages
      this.dutchieHistorySizes = form.dutchieHistorySizes
      this.metrcHistoryPages = form.metrcHistoryPages
      this.metrcHistorySizes = form.metrcHistorySizes
    }
  }
}

export type ConnectionsDetailsConnection = {
  current: boolean
  isConnected: boolean
  lastUpdatedAt: string
  licenseId: number
  licenseName: string
  licenseNumber: string
  relationshipId: number
  relationshipName: string
}

export type MetrcCollectionData = {
  connections: ConnectionsDetailsConnection[]
  history: HistoryEntity[]
  historyTotalCount: number
  id: number
  keyAddedDate: string
  key: string
}

export type BioTrackCollectionData = {
  connections: ConnectionsDetailsConnection[]
  history: HistoryEntity[]
  historyTotalCount: number
  id: number
  keyAddedDate: string
  email: string
  password: string
  ubi: string
}

export type DutchieCollectionData = {
  connections: ConnectionsDetailsConnection[]
  history: HistoryEntity[]
  historyTotalCount: number
  id: number
  keyAddedDate: string
  key: string
}

export type ConnectionsDetailsWebPage = {
  form: ConnectionsDetailsFormPayload
  licenseName: string
  licenseNumber: string
  showBioTrackCollection: BioTrackCollectionData[]
  showBioTrackCollectionConnected: boolean
  showDutchieCollection: DutchieCollectionData[]
  showDutchieCollectionConnected: boolean
  showMetrcCollection: MetrcCollectionData[]
  showMetrcCollectionConnected: boolean
}
